import type { GrowthStage, UserRole } from '../types';

export const SYSTEM_NAME = '工程北米 · 有机农产品全链条溯源系统';
export const SYSTEM_SHORT_NAME = '工程北米溯源';
export const COMPANY_NAME = '黑龙江工程北米农业科技有限公司';

export const GROWTH_STAGES: Array<{ key: GrowthStage; name: string; desc: string; order: number }> = [
  { key: 'seeding', name: '育苗阶段', desc: '恒温育苗、弱碱水培育壮秧', order: 1 },
  { key: 'transplanting', name: '插秧阶段', desc: '机械精准密植、活水灌溉', order: 2 },
  { key: 'growing', name: '田间生长', desc: '生物防治、有机肥料施入、田间除草', order: 3 },
  { key: 'harvesting', name: '秋季收割', desc: '适期脱水、收割测产、原粮入仓', order: 4 },
];

export const ROLE_CONFIGS: Record<UserRole, { name: string; description: string; defaultRoute: string }> = {
  admin: {
    name: '集团管理人员 (系统管理员)',
    description: '拥有全链路所有功能的一级最高管理权限',
    defaultRoute: '/dashboard',
  },
  manager: {
    name: '生产厂长 (基地主管)',
    description: '聚焦自有有机基地地块划分、种植农事录入与监控',
    defaultRoute: '/land/list',
  },
  oem: {
    name: 'OEM 代工厂商',
    description: '聚焦代工规格档案、胚芽米加工批次及赋码下载',
    defaultRoute: '/processing/orders',
  },
};

export const MA_CODE_RULES = {
  prefix: 'MA.156.A1.0058', // 默认工程北米企业标识
  categoryPrefix: 'AG.101', // 水稻谷物类目
  organicMark: 'ORG', // 有机认证
  greenMark: 'GRN', // 绿色食品
};

export const AUTH_STORAGE_KEYS = {
  token: 'north_rice_trace_token',
  user: 'north_rice_trace_user',
  tenantId: 'north_rice_trace_tenant',
};
